import { FormikProps } from 'formik';
import { ProductFormDetailsInterface, SelectedFile } from 'types/productTypes';
import { formatNumberWithCommasAnd2Decimals } from 'utils/maths/InputFormats';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import axios from 'axios';
import {
  setIsNoStock,
  setIsPieces,
  setIsNoFragment,
  setSearchResults,
  setSearchTerm,
  setDisplayVatPercentage,
  setError,
  setImgNameFromAPI,
  setIsDeleteImg,
  setSelectedFiles,
  apiError,
} from 'slices/product/form/reducer';
import {
  convertPngToJpg,
  resizeImage,
  formatBytes,
  convertToFileType,
} from 'utils/imageManipulation';
import {
  SUPPORTED_FILE_TYPES,
  MAX_FILE_SIZE,
  IMAGE_QUALITY,
} from '../ProductConstants';
import { TFunction } from 'i18next';
import { RootState } from 'slices';
import { getSearchProductsList, postAddImage } from 'services/productService';
import { MerchantInfo } from 'types/info/merchant';

export const handleChangeProductType = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<ProductFormDetailsInterface>,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const { value } = e.target;
  dispatch(setIsNoStock(value === '1'));
  dispatch(setIsPieces(value === '0'));
  if (value === '0') {
    dispatch(setIsNoFragment(true));
  }
  formik.setFieldValue('inventory_type', '1');
  formik.setFieldTouched('inventory_type', true);
  formik.setFieldValue('unit_type', '0');
  formik.setFieldTouched('unit_type', true);
};
export const handleChangeProductStockType = (
  e: React.ChangeEvent<HTMLSelectElement>,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const { value } = e.target;
  dispatch(setIsNoFragment(value !== '2'));
};
export const handleChangeUnitTypes = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<ProductFormDetailsInterface>,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const { value } = e.target;
  dispatch(setIsPieces(value === '0'));
  dispatch(setIsNoFragment(true));

  formik.setFieldValue('inventory_type', '1');
  formik.setFieldTouched('inventory_type', true);
};

export const handleChangeNumberInput = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<ProductFormDetailsInterface>
) => {
  const { name, value } = e.target;

  let rawValue = value.replace(/(?!^-)[^\d.]/g, '');

  if (rawValue.startsWith('-') && rawValue.length === 1) {
    formik.setFieldValue(name, rawValue);
  } else {
    rawValue = formatNumberWithCommasAnd2Decimals(rawValue);
    formik.setFieldValue(name, rawValue);
  }

  formik.setFieldTouched(name, true);
};

export const handleOnKeyUpNumberInput = (
  e: React.KeyboardEvent<HTMLInputElement>,
  formik: FormikProps<ProductFormDetailsInterface>
) => {
  const { name, value } = e.currentTarget;

  let rawValue = value.replace(/(?!^-)[^\d.]/g, '');

  if (rawValue.startsWith('-') && rawValue.length === 1) {
    formik.setFieldValue(name, rawValue);
  } else {
    rawValue = formatNumberWithCommasAnd2Decimals(rawValue);
    formik.setFieldValue(name, rawValue);
  }
};

//todo ===================== Modal ============================ //

export const handleSearch = async (
  term: string,
  merchant: MerchantInfo | Record<string, never>,
  isMerchantLoaded: boolean,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  if (!isMerchantLoaded || !merchant?.id || term.length < 3) return;

  try {
    //! FIXME: This value is currently fixed for testing. Update this logic in the future.
    const results = await getSearchProductsList(`${merchant.id}`, term);

    if (results) {
      const { message, error_code, data } = results;

      if (message === 'OK' && error_code === 0) {
        if (data && data.products) {
          dispatch(setSearchResults(data.products));
        } else {
          dispatch(setSearchResults([]));
        }
      } else {
        dispatch(setSearchResults([]));
      }
    } else {
      console.error('No response data returned');
      dispatch(setSearchResults([]));
    }
  } catch (error) {
    console.log(error);
    dispatch(setSearchResults([]));
  }
};
export const handleSearchChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  merchant: MerchantInfo | Record<string, never>,
  isMerchantLoaded: boolean,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const value = e.target.value;
  dispatch(setSearchTerm(value));
  handleSearch(value, merchant, isMerchantLoaded, dispatch);
};

//todo ===================== Modal ============================ //

//todo --------------- Handle Displaying Vat Percentage ----------------- //
export const handleBlurDisplayVatPercentage = (
  e: React.FocusEvent<HTMLInputElement, Element>,
  formik: FormikProps<ProductFormDetailsInterface>,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const display = formatNumberWithCommasAnd2Decimals(formik.values.vat);
  dispatch(setDisplayVatPercentage(`${display} %`));
  formik.handleBlur(e);
};

export const handleFocusDisplayVatPercentage = (
  formik: FormikProps<ProductFormDetailsInterface>,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const display = formatNumberWithCommasAnd2Decimals(formik.values.vat);
  dispatch(setDisplayVatPercentage(`${display}`));
};

export const handleChangeDisplayVatPercentage = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<ProductFormDetailsInterface>,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const { name, value } = e.target;

  const rawValue = value.replace(/[^\d.]/g, '');

  formik.setFieldValue(name, rawValue);
  formik.setFieldTouched(name, true);

  const display = formatNumberWithCommasAnd2Decimals(rawValue);
  dispatch(setDisplayVatPercentage(display));
};
export const handleOnKeyDisplayVatPercentage = (
  e: React.KeyboardEvent<HTMLInputElement>,
  formik: FormikProps<ProductFormDetailsInterface>,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const { name, value } = e.currentTarget;
  const rawValue = value.replace(/[^\d.]/g, '');
  formik.setFieldValue(name, rawValue);

  const display = formatNumberWithCommasAnd2Decimals(rawValue);
  dispatch(setDisplayVatPercentage(display));
};

//todo --------------- Handle Displaying Vat Percentage ----------------- //

export const handleAcceptedFiles = async (
  files: File[],
  isEdit: boolean,
  t: TFunction,
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  dispatch(setError(''));

  if (isEdit === true) {
    dispatch(setIsDeleteImg(1));
  }

  const filteredFiles = await Promise.all(
    files.map(async (file: File) => {
      if (!SUPPORTED_FILE_TYPES.includes(file.type)) {
        dispatch(
          setError(
            t('File') +
              ` ${file.name} ` +
              t('Warn_NotSupportFormat') +
              ' ' +
              t('Warn_PleaseUploadFileFormat')
          )
        );
        return null;
      }
      if (file.size > MAX_FILE_SIZE) {
        dispatch(setError(t('File') + ` ${file.name} ` + t('Warn_Exceed_5MB')));
        return null;
      }

      let tmpFile = file;
      if (file.type === 'image/png') {
        try {
          const jpgFile = await convertPngToJpg(file);
          tmpFile = jpgFile;
        } catch (error) {
          console.error('Error converting PNG to JPEG:', error);
        }
      }

      if (file.type.startsWith('image/')) {
        const resizedFile = await resizeImage(tmpFile, IMAGE_QUALITY);
        return resizedFile;
      }

      return file;
    })
  );

  const validFiles: File[] = filteredFiles.filter(
    (file): file is File => file !== null
  );

  const formattedFiles: SelectedFile[] = validFiles.map((file: File) =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  );

  dispatch(setSelectedFiles(formattedFiles));
  return formattedFiles;
};

export const sendImageAPI = async (
  image: SelectedFile[],
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const imgFile = await convertToFileType(image[0]);

  try {
    const response = await postAddImage(imgFile);

    if (response) {
      const { message, error_code, data } = response;

      if (message === 'OK' && error_code === 0) {
        if (data.file_name) {
          dispatch(setImgNameFromAPI(data.file_name));
        }
      } else {
        dispatch(apiError({ message, error_code }));
      }
    } else {
      console.error('No response data returned');
      dispatch(apiError({ message: 'No response data returned' }));
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errMsg =
        error.response?.data?.detail || 'An unexpected error occurred';
      console.error('Error in sendImageAPI:', errMsg);
      dispatch(apiError({ message: errMsg }));
    } else if (error instanceof Error) {
      console.error('Unexpected error:', error.message);
      dispatch(apiError({ message: error.message }));
    } else {
      console.error('Unknown error:', error);
      dispatch(apiError({ message: 'Unknown error occurred' }));
    }
  }
};

export const removeFile = (
  index: number,
  isEdit: boolean,
  selectedFiles: SelectedFile[],
  dispatch: ThunkDispatch<RootState, void, Action>
) => {
  const newFiles = [...selectedFiles];
  newFiles.splice(index, 1);
  dispatch(setSelectedFiles(newFiles));
  dispatch(setImgNameFromAPI(''));
  if (isEdit === true) {
    dispatch(setIsDeleteImg(1));
  }
};
